// LA PRIMA VERSIONE SI MOSTRA SENZA CIÒ CHE NON FA ANCORA NIENTE (utente, 2026-09-11): le sezioni
// vuote del rail — trigger point, texture, ambienti —, le righe spente di Effects e il filtro d'uso
// delle librerie. Niente di questo è stato cancellato: è scritto, spento, e non si disegna.
//
// La scelta è una sola e vive qui, perché si rimette tutta insieme: accendendo questo interruttore
// torna ogni segnaposto al suo posto, com'era prima. Chi invece dà un contenuto vero a una di
// quelle cose la toglie dal suo elenco — vedi `deferredToolNames` in SceneEditor — e da quel
// momento si mostra comunque.
export const SHOW_NOT_YET_AVAILABLE = false;
